// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3gzQS","label":"CategoryService_label__dVfo_","location":"CategoryService_location__3JmUt"};